const BASE_PATH = '/home'

export default {
  getRealDeviceInfo: query => ({
    url: `${BASE_PATH}/device/info/${query.siteId}`,
    method: 'GET'
  }),
  getRealAQI: query => ({
    url: `${BASE_PATH}/aqi/current/${query.siteId}`,
    method: 'GET'
  }),
  getRealAQIs: query => ({
    url: `${BASE_PATH}/aqi/${query.siteId}/${query.timeType}`,
    method: 'GET'
  }),
  getRealVOCsCategories: query => ({
    url: `${BASE_PATH}/vocs/category/${query.siteId}/${query.timeType}`,
    method: 'GET'
  }),
  getRealVOCsKeyFactors: query => ({
    url: `${BASE_PATH}/vocs/keystone/species/${query.siteId}/${query.timeType}`,
    method: 'GET'
  }),
  getRealSiteData: query => ({
    url: `${BASE_PATH}/site/data/${query.siteId}/${query.timeType}`,
    method: 'GET'
  }),
  getHeatMapData: query => ({
    url: `${BASE_PATH}/thermodynamic/data`,
    method: 'POST',
    data: query
  }),
  getCurrentCityAQI: query => ({
    url: '/city/aqi/now',
    method: 'GET'
  }),
  getCurrentDeviceStatus: () => ({
    url: '/device/online/malfunction/device',
    method: 'GET'
  }),
  getWindField: () => {
    let now = new Date()
    now.setHours(now.getHours(), 0, 0, 0)
    return {
      url: '/gfsJSON/gfs.json?ts=' + now.getTime(),
      method: 'GET'
    }
  },
  getNowAQI: () => ({
    url: `${BASE_PATH}/site/aqi/now`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Overview.js